angular.module('TurneroApp')
  .directive('compareTo', [function () {
  	return {
  		require: "ngModel",
  		scope: {
  			otherModelValue: "=compareTo"
  		},
  		link: function (scope, element, attributes, ngModel) {

  			ngModel.$validators.compareTo = function (modelValue) {
  				return modelValue == scope.otherModelValue

  			};

  			scope.$watch("otherModelValue", function () {
  				ngModel.$validate();
  			});
  		}
  	};
  }
  ])
.directive('forceSelectFocus', function() {
		return {
			restrict: 'A',
			require: ['^^mdSelect', '^ngModel'],
			link: function(scope, element, controller) {
				scope.$watch(function () {
					let foundElement = element;
					while (!foundElement.hasClass('md-select-menu-container')) {
						foundElement = foundElement.parent();
					}
					return foundElement.hasClass('md-active');
				}, function (newVal) {
					if (newVal) {
						element.focus();
					}
				})
			}
		}
	})
/*Directiva de seguridad de FE.
La funcionalidad es validar si el usuario tiene los permisos para poder ver la pantalla.
*/
.directive('permisos', ['seguridadService', 'TurneroAppConstant', function (seguridadService, TurneroAppConstant) {
	return function (scope, element, attrs) {
		var value = false;
		//seguridadService.permisos almacena los permisos del usuario. (los permisos, son los codigos de permisos, separados por coma).
		//en el primer paso validamos si el usuario no es SU (Superusuario), si lo fuera, saltamos todo lo demas y devolvemos true
		if (!seguridadService.permisos.contains(TurneroAppConstant.Permisos.SU)) {
			//Si no es SU, obtengo los permisos que deberia tener para poder ver la pantalla. (definido en el HTML de la misma).
			var atributos = attrs.permisos.split(",");
			//En el caso de permitir mas de un permiso, busca entre todos si alguno coincide con los permisos que tiene el usuario.
			if (atributos.length > 1) {
				for (var i = 0; i < atributos.length; i++) {
					//Si el atributo(permiso) esta contenido dentro de la lista de permisos que tiene el usuario. Es porque el usuario puede ver la pantalla.
					if (atributos[i] && seguridadService.permisos.contains(atributos[i])) {
						value = true;
						break;
					}
				}
			} else {
				//si solo es un permiso, lo busca en los permisos del usuario. sino es False.
				value = attrs.permisos  ? seguridadService.permisos.contains(attrs.permisos) : false;
			}
		} else {
			value = true;
		}
		//si value al momento de llegar aqui, es false, es porque el usuario no tiene los permisos para ver la pantalla o la seccion por lo que se agrega la clase hidden
		//si por el contrario, esta en true, se remueve la clase hidden del elemnto.
		if (value) {
			element.removeClass('hidden');
		} else {
			element.addClass('hidden');
		}
	}
}])
.directive('focusMe', ['$timeout', function ($timeout) {
	return {
		scope: {
			focusMe: "="
		},
		link: function (scope, element, attrs) {
			scope.$watch('focusMe', function (value) {
				value === true && $timeout(function () { element[0].focus(); });
			});

			element.bind('blur', function () {
				scope.$apply(function () {
					scope.focusMe = false;
				});
			});
		}
	};
}]);



// WEBPACK FOOTER //
// ./app/directives.js